const menOnBaseText = (basepaths) => {
    let base = ['', '', ''];
    let text = '';
    let dictKeys = '';
    let length = 0;
    let runners = 0;

    if (!basepaths) {
        return {
            text,
            dictKeys
        };
    }

    if (basepaths?.first) {
        base[0] = '1st';
    }
    if (basepaths?.second) {
        base[1] = '2nd';
    }
    
    if (basepaths?.third) {
        base[2] = '3rd';
    }

    length = base.length;
    
    for (let i = 1; i <= length; i++) {
        if (base[i-1]) {
            runners++;
            dictKeys = dictKeys + '_' + i;
            if (text === '') {
                text = ' at ' + base[i-1];
            } else {
                text = text + ' & ' + base[i-1];
            }
        }
    }
    
    if (runners === 0) {
        dictKeys = 'label_onbase_0';
        text= 'No runners on base'
    } else if (runners === 3) {
        dictKeys = 'label_onbase_1_2_3';
        text= 'Base loaded'
    } else {
        dictKeys = 'label_onbase' + dictKeys;
        text = 'Runner' + (runners > 1 ? 's ' : ' ') + text;
    }

    return {
        text,
        dictKeys,
        base
    };
};
 export default menOnBaseText;